import { render, staticRenderFns } from "./coupon-car.vue?vue&type=template&id=73219f85&"
import script from "./coupon-car.vue?vue&type=script&lang=js&"
export * from "./coupon-car.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports